import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import type { IReport } from '@/lib/interface';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TResponseData = IReport[];
const EMPTY_REPORTS: IReport[] = [];

export const useRequestGetReports = (run = true) => {
	const {
		isLoading,
		isFetching,
		data,
		error,
		dataUpdatedAt: reportsUpdatedAt,
		refetch: refetchReports
	} = useQuery({
		queryKey: [routes.api.reports.base, run],
		queryFn: ({ queryKey: [_url, _run] }) => (!_run ? Promise.resolve(null) : fetchQuery(_url as string))
	});

	const reports = data ?? EMPTY_REPORTS;

	const fetchQuery = (url: string) =>
		apiClient
			.get<TResponseData>(url)
			.then(handleApiResponse)
			.then(data =>
				[...(data ?? [])].map(l => ({
					...l,
					createdAt: dayjs(l.createdAt).toDate()
				}))
			);

	return {
		data: data as TResponseData,
		reportsUpdatedAt,
		isLoadingReports: isLoading,
		isRefetchingReports: isFetching && !isLoading,
		refetchReports,
		reports,
		error
	};
};
